import { cva } from "class-variance-authority"

/**
 * Distance Floating UI keeps between popover content and the collision
 * boundary (viewport by default). Shared with callers that pre-compute the
 * space a popover gets on a side before it opens.
 */
export const POPOVER_COLLISION_PADDING = 6

/**
 * Height a popover holding a searchable cmdk list wants when it opens: the
 * list cap (300px in `command/command.css`) plus the search row and
 * padding. `resolvePopoverOpenSide` opens on the top only when the bottom
 * offers less than this AND the top offers more; a trigger with room to
 * spare keeps the bottom.
 */
export const POPOVER_LIST_PREFERRED_HEIGHT = 360

/**
 * Width of the `md` size variant below (`w-64`), for callers that resolve
 * the alignment before the content exists (`resolvePopoverOpenAlign`).
 * Keep in step with the variant.
 */
export const POPOVER_CONTENT_WIDTH_MD = 256

export const popoverContentVariants = cva("ui-popover-content", {
  variants: {
    spacing: {
      true: "p-4",
      false: "",
    },
    size: {
      fit: "",
      md: "min-w-64 w-64 max-w-64",
      lg: "min-w-60 w-80 max-w-80",
      "match-trigger": "w-[var(--radix-popover-trigger-width)]",
    },
  },
  defaultVariants: {
    spacing: true,
    size: "md",
  },
})
